/**
 * Endereço antigo /list/places/:ids/places (botões da tela antiga de listas, links salvos):
 * cai na tela nova de Negócios locais com a lista escolhida (com várias, todas as listas).
 * Mantém ?download=1.
 */
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

export function PlacesRedirect(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [params] = useSearchParams();
  const ids = (id ?? '').split(',').filter(Boolean);
  const next = new URLSearchParams();
  next.set('list', ids.length === 1 ? ids[0]! : 'all');
  if (params.get('download') === '1') next.set('download', '1');
  const query = next.toString();
  return <Navigate to={`/places${query ? `?${query}` : ''}`} replace />;
}
